export default __webpack_public_path__ + "static/media/domen.442ed3bc.jpg";